import { render } from "./AssetsForm.vue?vue&type=template&id=028f4ede&scoped=true"
import script from "./AssetsForm.vue?vue&type=script&lang=js"
export * from "./AssetsForm.vue?vue&type=script&lang=js"

import "./AssetsForm.vue?vue&type=style&index=0&id=028f4ede&scoped=true&lang=css"

import exportComponent from "D:\\cwzl\\four-cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-028f4ede"]])

export default __exports__